if (!customElements.get("product-fixed-add-to-cart")) {
  class ProductFixedAddToCart extends HTMLElement {
    constructor() {
      super();
      this.onScrollHandler = this.handleVisibility.bind(this);
      this.querySelectorAll(
        ".product-fixed-add-to-cart__toggle-button"
      ).forEach((element) => {
        element.addEventListener("click", this.toggleModal.bind(this));
      });

      window.addEventListener("scroll", this.onScrollHandler);
    }

    toggleModal(e) {
      e.preventDefault();
      const shrinkClass = "product-fixed-add-to-cart--shrink";
      if (this.classList.contains(shrinkClass)) {
        this.classList.remove(shrinkClass);
      } else {
        this.classList.add(shrinkClass);
      }
    }

   handleVisibility() {
  const visibilityClass = "product-fixed-add-to-cart--visible";
  const footer = document.querySelector(".footer__heading");    
  const footerPosition = footer ? footer.getBoundingClientRect().top : 0;
  const windowHeight = window.innerHeight;
  const fixedAddtocartEl = document.querySelector(".product-form__button-row--fixed-atc-trigger");
  const fixedAddtocartElBottom = fixedAddtocartEl ? fixedAddtocartEl.getBoundingClientRect().bottom : 0;

  let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  let scrollHeight = document.documentElement.scrollHeight;
  if (footer && footerPosition <= windowHeight + 300) {
    // hide add to cart sticky button once its near the footer
    this.classList.remove(visibilityClass);
  } else {
    // show add to cart sticky button if the .product-form__button-row--fixed-atc-trigger is still visible
    if (fixedAddtocartElBottom < 0 && scrollTop < scrollHeight - windowHeight - 300) {
      this.classList.add(visibilityClass);
    } else {
      this.classList.remove(visibilityClass);
    }
  }
}

  }

  customElements.define("product-fixed-add-to-cart", ProductFixedAddToCart);
}

